import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
export const TextInput = (props) => {
  const inputChange = (eve) => {
    props.handleChange &&
      props.handleChange({
        ...props,
        value: eve.target.value,
        name: eve.target.name,
        index: props.index,
        formObject: props.formObject,
        ...eve
      });
  };
  return (
    <Input
      readOnly={props.readOnly}
      maxLength={props.htmlType === "email" ? 127 : props.maxLength}
      onChange={inputChange}
      disabled={props.disabled}
      placeholder={props.placeholder}
      value={props.value}
      type={props.htmlType}
      name={props.name}
      autoFocus={props.autoFocus}
      defaultValue={props.default}
      onKeyDown={props.onKeyDown}
      onPressEnter={props.onPressEnter}
      onClick={props.onClick}
      id={props.id}
      onBlur={props.onBlur}
      style={props.style}
      className={`${props.className || ''} ${!props.isValid ? ' error-field' : ''}`}
    />
  );
};
TextInput.propTypes = {
  handleChange: PropTypes.func.isRequired,
  index: PropTypes.number,
  disabled: PropTypes.bool,
  placeHolder: PropTypes.string,
  value: PropTypes.any,
  htmlType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isValid: PropTypes.bool,
};
